var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00154 5.5C6.00154 6.32843 5.32997 7 4.50154 7C3.67311 7 3.00154 6.32843 3.00154 5.5C3.00154 4.67157 3.67311 4 4.50154 4C5.32997 4 6.00154 4.67157 6.00154 5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2C0.671573 2 0 2.67157 0 3.5V12.5C0 13.3284 0.671573 14 1.5 14H14.5C15.3284 14 16 13.3284 16 12.5V3.5C16 2.67157 15.3284 2 14.5 2H1.5ZM14.5 3C14.7761 3 15 3.22386 15 3.5V9.49922L11.2251 7.5528C11.0327 7.45655 10.8002 7.49428 10.648 7.64646L6.93783 11.3566L4.27889 9.58399C4.08058 9.45178 3.81652 9.47793 3.64799 9.64646L1.00154 12V12.5395C1.00052 12.5265 1 12.5133 1 12.5V3.5C1 3.22386 1.22386 3 1.5 3H14.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigura);
export default __webpack_public_path__ + "static/media/figura.b640009ab75b8fe6f1b917e983d37670.svg";
export { ForwardRef as ReactComponent };